export enum OcrEvent {
    ADDED = 'ocr:added',
    COMPLETED = 'ocr:completed',
    FAILED = 'ocr:failed',
    VERIFY = 'ocr:verify',
    DELETE = 'ocr:delete',
}

export interface OcrEventPayload {
    params: { id: number };
}

export interface OcrEventMap {
    [OcrEvent.ADDED]: void;
    [OcrEvent.COMPLETED]: void;
    [OcrEvent.FAILED]: void;
    [OcrEvent.VERIFY]: OcrEventPayload;
    [OcrEvent.DELETE]: OcrEventPayload;
}
